import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  current: number;
  total: number;
  label?: string;
}
export function ProgressBar({
  current,
  total,
  label
}: ProgressBarProps) {
  const percentage = Math.round(current / total * 100);
  return <div className="w-full py-4" data-id="element-108">
      {label && <div className="flex justify-between items-center mb-2" data-id="element-109">
          <span className="text-sm font-medium text-gray-500" data-id="element-110">{label}</span>
          <span className="text-sm font-bold text-primary" data-id="element-111">{percentage}%</span>
        </div>}
      <div className="h-2.5 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-112">
        <motion.div className="h-full bg-primary rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-113" />
      </div>
    </div>;
}